export const userRouter = [
    {
        path: '/user',
        name: 'userPage',
        component: () => import('@/views/user/index.vue'),
        children: [
            {
                path: '/user/card',
                name: 'userCard',
                component: () => import('../views/user/card/index.vue'),
                meta: {
                    title: '练习卡'
                }
            },
            {
                path: '/user/card/:cardId',
                name: 'userCardCoupon',
                component: () => import('@/views/user/card/detail.vue'),
                meta: {
                    title: '练习卡'
                }
            },
            {
                path: '/user/cancle',
                name: 'userCancle',
                component: () => import('@/views/user/cancle.vue'),
                meta: {
                    title: '注销账号'
                }
            },
            {
                path: '/user/account',
                name: 'userAccount',
                component: () => 
                /* webpackChunkName: "user-account" */ import('@/views/user/account/index.vue'),
                meta: {
                    title: '我的学币'
                }
            },
            {
                path: '/user/recharge',
                name: 'userRecharge',
                component: () => 
                /* webpackChunkName: "user-account" */ import('@/views/user/account/recharge.vue'),
                meta: {
                    title: '历史记录'
                }
            },
            {
                path: '/user/interest',
                name: 'userInterest',
                component: () => 
                /* webpackChunkName: "user-account" */ import('@/views/user/account/interest.vue'),
                meta: {
                    title: '我的权益'
                }
            },
            {
                path: '/user/baozi',
                name: 'userBaozi',
                component: () => import('@/views/user/baozi/index.vue'),
                meta: {
                    title: '包子充值'
                }
            },
            {
                path: '/user/deviceManagement',
                name: 'userDeviceManagement',
                component: () => import('@/views/user/deviceManagement/index.vue'),
                meta: {
                    title: '登录设备管理'
                }
            }
        ]
    }
];
